<template>
  <div>
    <!-- <input v-model="barcodeValue" /><br />
    <barcode id="pdf" v-bind:value="barcodeValue">
       <p>text here</p> <p>more text</p>
      Show this if the rendering fails.
    </barcode>
    <button @click="print">Print</button>
    <div ></div> -->
    

    <button @click="printDemo">Test Print</button>
    <vue-easy-print :tableShow="true" ref="easyPrint">
      <!-- <POSPrinter /> -->
      <el-row>
      <el-col id="print"  :span="5">
        <barcode style="text-align: center; height: 78px" id="pdf" v-bind:value="'barcodeValue'" :width="1" :height="40" :fontSize="14" >
          rendering fails.
        </barcode>
        <p style="{
          margin-bottom: -4px !important;
          font-size: 12px;
          font-weight: bold;
          text-align: center; 
          margin-bottom: -4px !important;
          }">Rs 455</p>
        <p style="{
          margin-bottom: -4px !important;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
          margin-bottom: -4px !important;
          }">Barcode Scanner YHD-1100L</p>
      </el-col>
      </el-row>
      <!--  Write your own template for printing  -->
      <!-- <template slot-scope="func">
                <demo :getChineseNumber="func.getChineseNumber" ></demo>
            </template> -->
    </vue-easy-print>
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";
import POSPrinter from "./InvoiceTemplates/POSPrinter.vue";
import vueEasyPrint from "vue-easy-print";
export default {
  name: "createbarcode",
  components: {
    barcode: VueBarcode,
    POSPrinter,
    vueEasyPrint,
  },
  data() {
    return {
      barcodeValue: "test",
      text: '<p>text here</p> <p>more text</p>'
    };
  },
  created() {},
  methods: {
    printDemo() {
      // console.log("print");
      this.$refs.easyPrint.print();
    },
    async print() {
      // Pass the element id here
      await this.$htmlToPaper("pdf");
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/CreateBarcode.vue